export default "__VITE_ASSET__49049958__"